import type { FormData } from 'src/types/appState';

export const isSelectAdPageCompleted = (formData?: FormData) =>
  Boolean(formData?.selectedProductId);
